import _objectSpread from "/builds/huggg/sangria/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { translateObject } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../../config';
import { emailMap, hugggDeliveryReportMap, smsMap } from '../../translationMaps';
import getParams from '../../utils/getParams';
import withAxios from '../../utils/with-axios';

/**
 * Format the response data to convert snake_case to camelCase, and rename some
 * columns using the mappings provided.
 *
 * @param {Object} data API response data
 * @returns {Object} Formatted response data
 */
function formatAllResponse(response) {
  var translatedData = response.data.map(function (item) {
    if (item.email) {
      item.email = translateObject(emailMap, item.email);
    }
    if (item.sms) {
      item.sms = translateObject(smsMap, item.sms);
    }
    return _objectSpread({}, translateObject(hugggDeliveryReportMap, item));
  });
  response.data = translatedData;
  return response;
}

/**
 * Lists huggg delivery reports for an array of hugggIds
 *
 * @param {Object} [$axios=axios] Axios instance.
 * @param {String[]} hugggIds The array of huggg IDs
 *
 * @returns {Promise} Unresolved Promise from the API.
 * @throws {Error} If no userId provided
 */
function listByHugggIds(axios, hugggIds) {
  if (!hugggIds) {
    throw new Error('Prop `hugggIds` is required in `hugggDeliveryReports.listByHugggIds`');
  }
  var params = getParams({
    hugggId: hugggIds
  });
  return axios.get(urls.apiV2('/hugggs/delivery-reports'), {
    params: params
  }).then(prop('data')).then(formatAllResponse);
}
export default {
  listByHugggIds: withAxios(listByHugggIds)
};